module.exports = __webpack_public_path__ + "static/tickets_image-c7eb01218f0db7c11037034cd8102461.svg";